





























import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import uniqueString from 'unique-string';

import { menuModule } from '@/store/modules/menu';
import { IMenu } from '@/types/menu';
import NestedDraggable from './NestedDraggable.vue';
import EditItem from './EditItem.vue';
import TypeSelector from './TypeSelector.vue';
import TemplateSelector from './TemplateSelector.vue';
import { MenuMixins } from './MenuMixins';
import { AppModule } from '@/store/modules/app';

@Component({
  components: { TypeSelector, TemplateSelector, EditItem, NestedDraggable },
})
export default class MenuEdit extends mixins(MenuMixins) {
  menuData: IMenu[] = [];
  menuDataGhost: IMenu[] = [];
  loading: boolean = true;
  enableSort: boolean = false;
  inEditViewMenuPathArr: string[] = [];
  newItemRecord: Record<string, IMenu> = {};
  edittingItemRecord: Record<string, IMenu> = {};
  get templates() {
    return menuModule.templates;
  }

  get isSlidebarOpend() {
    return AppModule.sidebar.opened;
  }

  toSortView() {
    this.enableSort = true;
    this.menuDataGhost = _cloneDeep(this.menuData);
  }

  quitSortView() {
    this.enableSort = false;
    this.menuData = _cloneDeep(this.menuDataGhost);
  }

  async onSortConfirm() {
    await menuModule.changeMenuData(this.menuData);
    this.$message.success('修改成功');
    this.enableSort = false;
  }

  isMenuDisabledDelete(completePattern: string) {
    //'party/student/officea' 学生工作办公室
    //行政机构summarize/executive
    return ['dynamic', 'dynamic/notice', 'dynamic/news'].includes(completePattern);
  }

  isSpecialMenu(completePattern: string) {
    return ['summarize/executive'].includes(completePattern);
  }

  mounted() {
    Promise.all([menuModule.fetchMenuData(), menuModule.fetchTemplates()]).then(() => {
      this.menuData = _cloneDeep(menuModule.menuData);
      this.loading = false;
    });
  }

  onDragEnd(value) {
    this.menuData = value;
  }

  async deleteConfirm({
    pattern: completePattern,
    onSuccess,
  }: {
    pattern: string;
    onSuccess: () => void;
  }) {
    try {
      await this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      // 父菜单 pattern 路径
      const parentPatterns = completePattern.split('/');
      // 目标菜单
      const targetChildPattern = parentPatterns.pop();
      const menuData = _cloneDeep(this.menuData);
      let targetSubs = menuData;
      // 迭代获取需要删除的菜单兄弟数组集合
      parentPatterns.forEach((pattern) => {
        const findResult = targetSubs.find((i) => i.pattern === pattern);
        if (findResult) targetSubs = findResult.subs;
      });
      // 从兄弟数组中移除该菜单
      targetSubs.splice(
        targetSubs.findIndex((i) => i.pattern === targetChildPattern),
        1,
      );
      await menuModule.changeMenuData(menuData);
      this.$message.success('删除成功');
      this.menuData = menuData;
    } catch (error) {
      //
    }
  }

  // 提交新增的菜单
  async submitAddition({
    pattern: completePattern,
    menu,
    onSuccess,
  }: {
    pattern: string;
    menu: IMenu;
    onSuccess: () => void;
  }) {
    if (
      !menu.name ||
      !menu.type ||
      (menu.type === 'list' && !menu.templatePattern) ||
      (menu.type === 'link' && !menu.redirectUrl)
    ) {
      this.$message.error('缺少必要信息');
      return;
    }
    const parentPatterns = completePattern.split('/');
    const menuData = _cloneDeep(this.menuData);
    let targetSubs = menuData;
    parentPatterns.forEach((pattern) => {
      const findResult = targetSubs.find((i) => i.pattern === pattern);
      if (findResult) targetSubs = findResult.subs;
    });
    if (targetSubs.find((i) => i.pattern === menu.pattern)) {
      this.$message.error('pattern 重复，请重新输入');
      return;
    }
    let uniquePattern: string;
    do {
      uniquePattern = uniqueString();
    } while (targetSubs.find((i) => i.pattern === uniquePattern));
    targetSubs.push({ ...menu, pattern: uniquePattern });

    await menuModule.changeMenuData(menuData);
    this.menuData = menuData;
    this.$message.success('添加成功');
    onSuccess();
  }

  // 保存菜单修改
  async save({
    pattern: completePattern,
    menu,
    onSuccess,
  }: {
    pattern: string;
    menu: IMenu;
    onSuccess: () => void;
  }) {
    if (
      !menu.name ||
      !menu.pattern ||
      !menu.type ||
      (menu.type === 'list' && !menu.templatePattern) ||
      (menu.type === 'link' && !menu.redirectUrl)
    ) {
      this.$message.error('缺少必要信息');
      return;
    }

    const patterns = completePattern.split('/');
    const menuData = _cloneDeep(this.menuData);
    let targetMenuInSubsIndex;
    let targetSubs = menuData;
    patterns.forEach((pattern, index) => {
      const findResultIndex = targetSubs.findIndex((i) => i.pattern === pattern);
      if (findResultIndex > -1) {
        targetMenuInSubsIndex = findResultIndex;
        if (index !== patterns.length - 1) {
          targetSubs = targetSubs[findResultIndex].subs;
        }
      }
    });

    if (targetSubs[targetMenuInSubsIndex].type !== menu.type) {
      await this.$confirm(
        '更改菜单类型，即将影响前台菜单页面的展示，现有页面数据将会被清空，是否继续？',
        { type: 'warning' },
      );
    } else if (targetSubs[targetMenuInSubsIndex].templatePattern !== menu.templatePattern) {
      await this.$confirm(
        '更改菜单模板，即将影响前台菜单页面的展示，现有页面数据将会被清空，是否继续？',
        { type: 'warning' },
      );
    }

    // 新菜单写入原菜单结构数组
    targetSubs[targetMenuInSubsIndex] = { ...menu };

    await menuModule.changeMenuData(menuData);
    this.menuData = menuData;
    this.$message.success('修改成功');
    onSuccess();
  }
}
